module.exports = __webpack_public_path__ + "static/media/image-power@2x.1dc12944.png";